import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A substation busbar rack: a steel A-frame gantry carrying three horizontal
// copper busbars, each standing on a post insulator. The shared rail that ties
// a switchyard's circuits together.
const STEEL = "#878e96";
const STEEL_DK = "#6c727a";
const INSUL = "#9aa6ad";
const BUS = "#b87333";

function postInsulator(x: number, y: number, z: number): Part[] {
  const out: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.025, 0.03, 0.18, 8), color: INSUL, position: [x, y, z] },
  ];
  for (let i = 0; i < 3; i++) {
    out.push({ geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.015, 8), color: "#aab4ba", position: [x, y - 0.06 + i * 0.06, z] });
  }
  return out;
}

export const busbarRack = defineModel({
  id: "busbar-rack",
  batchId: "electric",
  name: "Busbar rack",
  tags: ["prop", "electric", "power", "grid", "substation", "busbar"],
  summary: "A steel gantry carrying three copper busbars on post insulators.",
  footprint: 0.6,
  parts(): Part[] {
    const parts: Part[] = [];
    // Two A-frame posts with feet.
    for (const x of [-0.6, 0.6]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.06, 0.9, 0.06), color: STEEL, position: [x, 0.45, 0] });
      parts.push({ geometry: new THREE.BoxGeometry(0.18, 0.06, 0.18), color: STEEL_DK, position: [x, 0.03, 0] });
      parts.push({ geometry: new THREE.BoxGeometry(0.06, 0.06, 0.4), color: STEEL_DK, position: [x, 0.9, 0] });
    }
    // Cross beam.
    parts.push({ geometry: new THREE.BoxGeometry(1.26, 0.06, 0.08), color: STEEL, position: [0, 0.9, 0] });
    // Three busbars on post insulators at staggered depths.
    const zrows = [-0.13, 0, 0.13];
    for (const z of zrows) {
      parts.push(...postInsulator(-0.6, 1.02, z), ...postInsulator(0.6, 1.02, z));
      parts.push({ geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 10), color: BUS, position: [0, 1.13, z], rotation: [0, 0, Math.PI / 2] });
    }
    return parts;
  },
  animations: [],
});
